import { Field } from 'redux-form';
import { acceptance } from 'redux-form-validators';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CheckboxGroupLabelLeft } from '../../../../../../../../../common/components/ReduxFormField';

const DirectDebitDeclaration = ({ input }) => {
  return (
    <Row>
      <Col sm={12}>
        <Field
          name={`${input.name}.answer`}
          inline
          options={[
            {
              label: input.value.question,
              value: true,
            },
          ]}
          component={CheckboxGroupLabelLeft}
          validate={acceptance({ message: 'Required' })}
        />
      </Col>
    </Row>
  );
};

const DirectDebitDeclarations = ({ fields }) => {
  return fields.map((field) => <Field name={field} component={DirectDebitDeclaration} />);
};

export default DirectDebitDeclarations;
